import { render } from "./WorkloadView.vue?vue&type=template&id=2d3c9fc2&scoped=true"
import script from "./WorkloadView.vue?vue&type=script&lang=js"
export * from "./WorkloadView.vue?vue&type=script&lang=js"

import "./WorkloadView.vue?vue&type=style&index=0&id=2d3c9fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3c9fc2"]])

export default __exports__